import React from 'react';
     import { Link } from 'react-router-dom';
     import NavigationBar from './NavigationBar';
     import { notificationStyles } from '../utils';

     const NotFoundPage = () => {
       return (
         <div className="min-h-screen flex flex-col">
           <NavigationBar />
           <div className="flex-1 p-6 bg-gray-50 dark:bg-gray-900 min-h-screen flex items-center justify-center pt-16">
             <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg max-w-md w-full text-center">
               <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">Page Not Found</h2>
               <div className="mb-4 p-4 rounded-lg border" style={notificationStyles.error}>
                 The page you are looking for does not exist.
               </div>
               <Link
                 to="/dashboard"
                 className="inline-block bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-200"
               >
                 Return to Dashboard
               </Link>
             </div>
           </div>
         </div>
       );
     };

     export default NotFoundPage;
